module.exports = __webpack_public_path__ + "static/media/MatthewIncardona.6f53f936.webp";